import EdgeLabel from '../enums/edgeLabel';

function getEdgeFromString(value: string | null) {
	switch (value) {
		case 'Top':
			return EdgeLabel.TOP;
		case 'Bottom':
			return EdgeLabel.BOTTOM;
		case 'Left':
			return EdgeLabel.LEFT;
		case 'Right':
			return EdgeLabel.RIGHT;

		default:
			break;
	}
}

export default getEdgeFromString;
